export default "__VITE_ASSET__BRjgJ1vI__"